import ConvertLeads from './container/index';

export default ConvertLeads;


// WEBPACK FOOTER //
// ./src/views/ConvertLeads/index.js